import LocalizedStrings from 'localized-strings';

interface CreateNewTransferCheckDetailsLocalizedType {
  checkDetails: string;
  targetAmount: string;
  totalAmount: string;
  exchangeRate: string;
  confirm: string;
  internationalTransfer: string;
  convertedAmount: string;
  commission: string;

  transferRecap: string;
  transferType: string;
  additionalInformation: string;
  commissionDetails: string;
  label: string;
  amountExcludingVAT: string;
}

export default new LocalizedStrings<CreateNewTransferCheckDetailsLocalizedType>(
  {
    en: {
      additionalInformation: 'Additional information',
      amountExcludingVAT: '{amount} excl. VAT',
      checkDetails: 'Verify information',
      commission: 'Shine commission',
      commissionDetails:
        'We charge a handling fee of {variableFee} excl. VAT of the amount sent (with a minimum of {minimumFee} excl. VAT) per international transfer.',
      confirm: 'Confirm transfer',
      convertedAmount: 'Converted amount',
      exchangeRate: 'Exchange rate',
      internationalTransfer: 'International',
      label: 'Label',
      targetAmount: 'Your beneficiary receives',
      totalAmount: 'Your total',
      transferRecap: 'Transfer summary',
      transferType: 'Type of transfer',
    },
    fr: {
      additionalInformation: 'Informations complémentaires',
      amountExcludingVAT: '{amount} HT',
      checkDetails: 'Vérifiez les informations',
      commission: 'Commission Shine',
      commissionDetails:
        'Nous facturons des frais de gestion de {variableFee} HT du montant envoyé (avec un minimum de {minimumFee} HT), lorsque vous émettez un virement international.',
      confirm: 'Confirmer l’envoi',
      convertedAmount: 'Montant converti',
      exchangeRate: 'Taux de change',
      internationalTransfer: 'International',
      label: 'Libellé',
      targetAmount: 'Votre bénéficiaire reçoit',
      totalAmount: 'Votre total',
      transferRecap: 'Récapitulatif du virement',
      transferType: 'Type de virement',
    },
  } as const,
);
